import { Injectable } from '@angular/core';
import { NestApiProvider } from '../../nest-api';
import { Observable } from 'rxjs';
import {
  RequestChangePasswordDto,
  RequestLogoutByTokenDto,
  RequestRefreshTokenDto,
  RequestResetPasswordDto,
  RequestSetDevicePINDto,
  RequestSwitchLanguage,
  ResponseChangePasswordDto,
  ResponseLogoutAllDto,
  ResponseLogoutByTokenDto,
  ResponseLogoutDto,
  ResponseLogoutOthersDto,
  ResponsePasswordSettingDto,
  ResponseProfileDto,
  ResponseSetDevicePINDto,
  ResponseSwitchCompanyDto,
  ResponseTokenListsDto,
} from '../dto/auth.dto';
import { ResponseData } from '../../nest-responses';
import { GDAuthInterface } from '../../../../model/gd-auth';
import { HttpHeaders } from '@angular/common/http';
import moment from "moment";

@Injectable()
export class AuthApi {

  private readonly service: string = '';
  private readonly model: string = 'auth';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public passwordSetting(companyCode: string = null): Observable<ResponsePasswordSettingDto> {
    const method: string = 'GET';
    const func: string = 'passwordSetting';
    const params: any = {};
    const urlParams: any = (companyCode) ? {
      ist: companyCode
    } : null;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePasswordSettingDto>(method, url, func, params, body, null, null, true);
  }

  public changePassword(payload: RequestChangePasswordDto): Observable<ResponseChangePasswordDto> {
    const method: string = 'POST';
    const func: string = 'changePassword';
    const params: any = {
      passn: payload.passn,
      passc: payload.passc
    };
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseChangePasswordDto>(method, url, params, urlParams, body);
  }

  public isHRAdmin(): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'isHRAdmin';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public setDevicePIN(payload: RequestSetDevicePINDto): Observable<ResponseSetDevicePINDto> {
    const method: string = 'POST';
    const func: string = 'setDevicePIN';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSetDevicePINDto>(method, url, params, urlParams, body);
  }

  public logout(): Observable<ResponseLogoutDto> {
    const method: string = 'POST';
    const func: string = 'logout';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseLogoutDto>(method, url, params, urlParams, body);
  }

  public logoutOthers(): Observable<ResponseLogoutOthersDto> {

    const method: string = 'POST';
    const func: string = 'logoutOthers';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseLogoutOthersDto>(method, url, params, urlParams, body);
  }

  public logoutAll(): Observable<ResponseLogoutAllDto> {

    const method: string = 'POST';
    const func: string = 'logoutAll';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseLogoutAllDto>(method, url, params, urlParams, body);
  }

  public logoutByToken(payload: RequestLogoutByTokenDto): Observable<ResponseLogoutByTokenDto> {

    const method: string = 'POST';
    const func: string = 'logoutByToken';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseLogoutByTokenDto>(method, url, params, urlParams, body);
  }

  public tokenLists(limit: string | number, page: string | number): Observable<ResponseTokenListsDto> {
    const method: string = 'GET';
    const func: string = 'tokenLists';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) urlParams.page = page;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseTokenListsDto>(method, url, func, params, body);
  }

  public profile(): Observable<ResponseData<ResponseProfileDto>> {
    const method: string = 'GET';
    const func: string = 'profile';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseProfileDto>>(method, url, params, urlParams, body, null, null, null, false);
  }

  public refreshToken(payload: RequestRefreshTokenDto): Observable<any> {

    const method: string = 'POST';
    const func: string = 'refreshToken';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public switchCompany(data): Observable<ResponseSwitchCompanyDto> {
    const method: string = 'GET';
    const func: string = 'switchCompany';
    const params: any = {};
    const urlParams: any = {
      companyId: data
    };
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSwitchCompanyDto>(method, url, params, urlParams, body);
  }

  public lifeSpanPassword(): Observable<ResponseData<boolean>> {
    const method: string = 'GET';
    const func: string = 'lifeSpanPassword';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const timeout: number = 3000;
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<boolean>>(method, url, params, urlParams, body, null, timeout);
  }

  public checkLDAP(companyCode: string): Observable<ResponseData<boolean>> {
    const method: string = 'GET';
    const func: string = 'checkLDAP';
    const params: any = {};
    const urlParams: any = {
      ist: companyCode
    };
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<boolean>>(method, url, params, urlParams, body);
  }

  public checkLDAPNoToken(companyCode: string, username?: string): Observable<ResponseData<boolean>> {
    const method: string = 'GET';
    const func: string = 'checkLDAP';
    const params: any = {};
    const urlParams: any = {
      ist: companyCode,
      uid: (username) ? btoa(username) : undefined
    };
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<boolean>>(method, url, params, urlParams, body, null, null, true);
  }

  public switchLanguage(payload: RequestSwitchLanguage): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = 'switchLanguage';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public resetPassword(payload: RequestResetPasswordDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'resetPassword';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public customLoginData(url: string, token: string): Promise<GDAuthInterface> {
    const isWebview = localStorage.getItem('webOpenFromWebview');
    return this.nestApiProvider.http.get<GDAuthInterface>(`${url}/auth/loginData?access_token=${token}&v=${moment().format('YYYY-MM-DD')}`,
      { headers: (isWebview) ? new HttpHeaders().append('authorization', token).append("app", "gd8") : new HttpHeaders().append('authorization', token) }).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/auth.api.ts